"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = void 0;

var isNumber = function isNumber(val) {
  return typeof val === 'number';
};

var getSize = function getSize(value) {
  return isNumber(value) ? value + "px" : value;
};

exports.getSize = getSize;